import {Component, Input, OnInit} from '@angular/core';
import {ErrorService} from '@app/services';
import {CreditSearchParams} from '../credit-search-params';
import {CreditService} from '../credit.service';
@Component({
  selector: 'hpf-credit-count',
  templateUrl: './credit-count.component.html'
})
export class CreditCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: CreditSearchParams = new CreditSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private creditService: CreditService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.creditService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
